import React from "react";
import Modal from "../../components/Modal";
import Button from "../../components/Button";
import type { Transaction } from "../../../src/pages/loans/LoanDues";
import { fmtCurrency, fmtDate } from "../../../src/pages/loans/LoanDues"; // or export from util

type Props = {
  isOpen: boolean;
  onClose: () => void;
  selectedTransactions: Transaction[];
  selectedTransaction: Transaction | null;
  onSelect: (tx: Transaction) => void;
  onDownload: (tx: Transaction | null) => void;
  downloadingId?: number | null;
  isCustomer: boolean;
};

export default function TransactionModal({ isOpen, onClose, selectedTransactions, selectedTransaction, onSelect, onDownload, downloadingId, isCustomer }: Props) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Transaction Details">
      {selectedTransactions.length > 0 ? (
        <div className="space-y-3">
          {selectedTransactions.map((tx) => (
            <div key={tx.transaction_id} onClick={() => onSelect(tx)} className={`p-3 rounded border ${selectedTransaction?.transaction_id === tx.transaction_id ? "border-indigo-300 bg-indigo-50" : "border-gray-100"}`}>
              <div className="flex items-start justify-between">
                <div>
                  <div className="text-sm text-gray-600">Receipt ID: <span className="font-medium">{tx.transaction_id}</span></div>
                  <div className="text-sm text-gray-600">Amount Paid: <span className="font-medium">{fmtCurrency(tx.amount_paid)}</span></div>
                  <div className="text-sm text-gray-600">Payment Mode: <span className="font-medium">{tx.payment_mode}</span></div>
                  <div className="text-sm text-gray-600">Reference #: <span className="font-medium">{tx.reference_number ?? "-"}</span></div>
                  <div className="text-sm text-gray-600">Status: <span className="font-medium">{tx.status}</span></div>
                  <div className="text-sm text-gray-600">Date: <span className="font-medium">{fmtDate(tx.created_at)}</span></div>
                </div>
                <div className="flex flex-col items-end gap-2">
                  <Button onClick={() => onDownload(tx)} disabled={downloadingId === tx.transaction_id} className="px-3 py-1 text-xs rounded bg-sky-600 text-white disabled:opacity-60">
                    {downloadingId === tx.transaction_id ? "Downloading..." : "Download PDF"}
                  </Button>
                </div>
              </div>
            </div>
          ))}

          {selectedTransaction && !isCustomer && (
            <div className="mt-4 p-3 border border-gray-400 rounded bg-white">
              <h4 className="text-sm font-semibold mb-2">Selected Transaction</h4>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 text-sm text-gray-600">
                <div>Processed By (ID): <span className="font-medium">{selectedTransaction.processed_by ?? selectedTransaction.user_id}</span></div>
                <div>Processed By Role: <span className="font-medium">{selectedTransaction.processed_by_role ?? "-"}</span></div>
                <div>Processed By Id: <span className="font-medium">{selectedTransaction.processed_by_id ?? "-"}</span></div>
                <div>Additional Amount: <span className="font-medium">{fmtCurrency(selectedTransaction.additional_amount)}</span></div>
                <div>Adjustment Amount: <span className="font-medium">{fmtCurrency(selectedTransaction.adjustment_amount)}</span></div>
              </div>
            </div>
          )}
        </div>
      ) : (
        <div className="text-sm text-gray-600">No transaction found for this schedule.</div>
      )}
    </Modal>
  );
}
